import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

const getOrgMarketPlacesOptions = (orgId: string) =>
  queryOptions({
    queryKey: ["orgMarketplaces", orgId],
    queryFn: async () => await apiClient.getOrganizationMarketplaces({ params: { orgId } }),
  });

export function useOrgMarketplaceKeys() {
  const { organization_id } = useAppSelector((state) => state.user);
  return useQuery({
    ...getOrgMarketPlacesOptions(organization_id),
    select: (data) => Object.keys(data.markets),
  });
}
